/* eslint-disable */
require('./crop')
